import { Tag } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const CustomTag = ({ label, closable = false, onClose = null, ...props }) => {
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Tag
      color="#4A699C"
      onMouseDown={onPreventMouseDown}
      onClose={onClose}
      className="custom-tag mt-1 mb-1"
      {...props}
    >
      {closable && <CloseOutlined onClick={onClose} className="me-1" />}
      {label}
    </Tag>
  );
};

CustomTag.propTypes = {
  label: PropTypes.string.isRequired,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
};

export default CustomTag;
